(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/components/cart-bottom-sheets.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/components/cart-bottom-sheets.js');
"use strict";


const CartBottomSheet = svs.ticketsOrderHome.components.CartBottomSheet;
const {
  useOrderHomeContext
} = svs.ticketsOrderHome.context;
const {
  ReactButton: Button
} = svs.ui;
const formatCurrency = svs.utils.format.Currency;
const CartBottomSheetContinueSubmit = _ref => {
  let {
    disabled,
    formId
  } = _ref;
  const {
    state,
    incrementOrderCount,
    decrementOrderCount
  } = useOrderHomeContext();
  const {
    tickets,
    totalOrderCount,
    totalOrderPrice,
    shippingCost,
    minimumTotalOrderPriceNotReached
  } = state.cart;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    form: formId,
    inverted: true,
    type: "submit"
  }, "Forts\xE4tt"), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
const CartBottomSheetContinue = _ref2 => {
  let {
    onContinue,
    disabled
  } = _ref2;
  const {
    state,
    incrementOrderCount,
    decrementOrderCount
  } = useOrderHomeContext();
  const {
    tickets,
    totalOrderCount,
    totalOrderPrice,
    shippingCost,
    minimumTotalOrderPriceNotReached
  } = state.cart;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    inverted: true,
    onClick: onContinue
  }, "Forts\xE4tt"), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
const CartBottomSheetPay = _ref3 => {
  let {
    onPay,
    disabled
  } = _ref3;
  const {
    state,
    incrementOrderCount,
    decrementOrderCount
  } = useOrderHomeContext();
  const {
    tickets,
    totalOrderCount,
    totalOrderPrice,
    shippingCost,
    minimumTotalOrderPriceNotReached
  } = state.cart;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    focus: true,
    onClick: onPay
  }, "Betala ".concat(formatCurrency(totalOrderPrice), " kr")), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
const CartBottomSheetDynamicAction = _ref4 => {
  let {
    onContinue,
    onPay,
    disabled,
    readyToPay
  } = _ref4;
  const {
    state,
    incrementOrderCount,
    decrementOrderCount
  } = useOrderHomeContext();
  const {
    tickets,
    totalOrderCount,
    totalOrderPrice,
    shippingCost,
    minimumTotalOrderPriceNotReached
  } = state.cart;
  return React.createElement(CartBottomSheet, {
    decrementOrderCount: decrementOrderCount,
    incrementOrderCount: incrementOrderCount,
    minimumTotalOrderPriceNotReached: minimumTotalOrderPriceNotReached,
    shippingCost: shippingCost,
    tickets: tickets,
    totalOrderCount: totalOrderCount,
    totalOrderPrice: totalOrderPrice
  }, React.createElement(React.Fragment, null, readyToPay ? React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    focus: true,
    onClick: onPay
  }, "Betala ".concat(formatCurrency(totalOrderPrice), " kr")) : React.createElement(Button, {
    block: true,
    disabled: minimumTotalOrderPriceNotReached || disabled,
    inverted: true,
    onClick: onContinue
  }, "Forts\xE4tt"), React.createElement("p", {
    className: "margin-v-half align-center"
  }, minimumTotalOrderPriceNotReached ? 'Minsta ordervärde är 90 kr plus porto' : '', "\xA0")));
};
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinueSubmit', CartBottomSheetContinueSubmit);
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinue', CartBottomSheetContinue);
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetPay', CartBottomSheetPay);
setGlobal('svs.ticketsOrderHome.orderHome.components.CartBottomSheetDynamicAction', CartBottomSheetDynamicAction);

 })(window);